// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ancujowsxivyfnxhnsmr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFuY3Vqb3dzeGl2eWZueGhuc21yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTMzNjQ3NzQsImV4cCI6MjA2ODk0MDc3NH0.0gn-VwFaeV9NC-LO-VdL0blL2LnyB4uYCF0aNF9Ic6U";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});